import { render, staticRenderFns } from "./TabelaProtocolos.vue?vue&type=template&id=3638d1cb&"
import script from "./TabelaProtocolos.vue?vue&type=script&lang=js&"
export * from "./TabelaProtocolos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports